import emitEvent from './emitEvent';
import { validateEventProps } from './validateEventProps';
import { reportTrackerFailure } from '../rollbar';

export default ({ name, version, getCalltimePayload }) => (payload) => {
  const { locale, learnLanguageCode } = payload;
  validateEventProps({ name, version, locale, learnLanguageCode, ...payload });

  return emitEvent({
    name,
    version,
    payload: {
      locale,
      learn_language_alpha3: learnLanguageCode,
      ...getCalltimePayload(payload)
    },
    error: (error) => reportTrackerFailure(error, name, payload)
  });
};
